import React from 'react';
import styled from 'styled-components/macro';
import Modal from './Modal';
import { ga } from '../lib/analytics';
import { LinkStyled, Paragraph, Hr } from './typography';
import { BsFillPlusCircleFill } from './Icons';
import Div from './Div';

const StyledModal = styled(Modal)`
overflow-y: visible;
  padding: 15px;
  width: 90%;
  max-width: calc(500px - 30px);

  @media (max-width: 991px) {
    top: 15px !important;
    transform: translate(-50%,10px) !important;
    max-height: calc(100% - 120px);
  }
`;
const ScrollDiv = styled(Div)`
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: calc(100vh - 120px);
`;
const CloseButton = styled.div`
  color: ${({ theme }) => theme.colors.colorRed};
  border: 2px solid ${({ theme }) => theme.colors.colorWhite};
  position: absolute;
  display: flex;
  top: -7px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 30px;
  background: white;
  rotate: 45deg;
  border-radius: 100%;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: ${({ theme }) => theme.hoverColors.colorRed};
  }
`;

export default class HoldbarhedPopupLink extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.onClose = this.onClose.bind(this);
    this.state = {
      open: false,
    };
  }

  onClick() {
    this.setState({ open: true });
    ga('event', 'open', { event_category: 'holdbarhed' });
  }

  onClose() {
    this.setState({ open: false });
    ga('event', 'close', { event_category: 'holdbarhed' });
  }

  render() {
    const {
      name,
      ...props
    } = this.props;
    const link = <LinkStyled action noStyle {...props} onClick={this.onClick} />;
    const { open } = this.state;
    if (open) {
      return (
        <React.Fragment>
          {link}
          <StyledModal
            isOpen
            onRequestClose={this.onClose}
          >
            <ScrollDiv>
              <Paragraph fontSize="20px" bold>Holdbarhed på åbnede fadølsfustager</Paragraph>
              <Paragraph fontSize="16px">
                Når fustagen er anbrudt er holdbarheden typisk 7 - 14 dage. Efterhånden som tiden går ændres smagen og der vil være en større tendens til at øllet skummer.
              </Paragraph>
              <Paragraph fontSize="16px">
                Når fustagen er anbrudt må den ikke opbevares under 15 grader.
              </Paragraph>
              <Paragraph fontSize="16px">
                Ovenstående gælder fadølsanlæg tilsluttet kulsyreflaske. Brug af kompressor reducerer holdbarheden markant.
              </Paragraph>
              <Hr />
              <Paragraph fontSize="16px" bold>Holdbarhed på uåbnede fadølsfustager</Paragraph>
              <Paragraph fontSize="16px">
                Som på andre fødevarer er holdbarheden &quot;bedst før&quot; anført direkte på fustagen.
              </Paragraph>
              <Paragraph fontSize="16px">
                Typisk er holdbarheden ca. 9 måneder fra tappedatoen. Hancock fustager har dog kun 2 måneder fra tappedatoen. Sædvanligvis smager øllet i fustagerne godt lang tid efter &quot;bedst før&quot; datoen, da øllet ligger mørkt og forseglet i fustagerne.
              </Paragraph>
            </ScrollDiv>
            <CloseButton onClick={this.onClose}><BsFillPlusCircleFill /></CloseButton>
          </StyledModal>
        </React.Fragment>
      );
    }
    return link;
  }
}
